module.exports = __webpack_public_path__ + "static/dealersyslongtransparent-807e5459cdc928155b7d22e694b9e576.png";